module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fR2a0"))).then(() => parcelRequire('f4eak'));